// src/hooks/transportations/useUpdateTransportation.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateTransportation } from "../../api/apiTransportations";
import parseError from "../../utils/parseError";

const useUpdateTransportation = () => {
    const queryClient = useQueryClient();

    const {
        mutate: editTransportation,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, req }) => updateTransportation(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["transportations"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update transportation");
        },
    });

    return {
        editTransportation,
        isUpdate: isPending || isLoading,
    };
};

export default useUpdateTransportation;
